







import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import i18n from '@/i18n'

@Component({
  name: "railway-placeholder",
  components: {
  }
})
export default class RailwayPlaceholder extends Vue {
  get placeholderUrl() {
    return require('@/assets/railway/placeholder-' + i18n.locale + '.jpg')
  }
}
